import { render, staticRenderFns } from "./TranslationInput.vue?vue&type=template&id=5d4a7f1b"
import script from "./TranslationInput.vue?vue&type=script&lang=ts"
export * from "./TranslationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports